export default "__VITE_ASSET__Bdi6Huj___"